import { useMentiSpring } from '@mentimeter/motion/spring';
import { animated } from 'react-spring';
import { getContrastingTextColor } from '../../utils/colors';

const SEGMENT_WITH_TEXT_MIN_HEIGHT = 38;
const TEXT_MARGIN_TOP = 3;

interface SegmentValueProps {
  segmentX: number;
  segmentY: number;
  segmentHeight: number;
  segmentWidth: number;
  segmentColor: string;
  text: string;
  animateFromY: number;
  disableAnimations?: boolean;
}
export const SegmentValue = ({
  segmentX,
  segmentY,
  segmentColor,
  text,
  segmentHeight,
  segmentWidth,
  animateFromY,
  disableAnimations = false,
}: SegmentValueProps) => {
  const [springStyles] = useMentiSpring({
    from: {
      y: animateFromY,
    },
    to: {
      y: segmentY + segmentHeight / 2 + TEXT_MARGIN_TOP,
    },
    immediate: disableAnimations,
  });

  // 38 is inspected the height after setting the font size, getting from a ref seems like a overkill for this case
  const hasEnoughSpaceForText = segmentHeight > SEGMENT_WITH_TEXT_MIN_HEIGHT;
  if (!hasEnoughSpaceForText) {
    return null;
  }

  const textColor = getContrastingTextColor(segmentColor);
  return (
    <animated.text
      x={segmentX + Math.min(16, segmentWidth * 0.2)}
      y={springStyles.y}
      fill={textColor}
      textAnchor="start"
      dominantBaseline="middle"
      fontSize={`min(${segmentWidth * 0.4}, 32)`}
    >
      {text}
    </animated.text>
  );
};
